var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.name},[_vm._v("\n  "+_vm._s(_vm.$t('module_bidding_cap_the_cost_of_in_app_event'))+"\n  "),_c('tooltip-info',{attrs:{"tips":_vm.$t('module_bidding_cap_the_cost_of_in_app_event_tip')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }